import React from 'react'

export const ColorSwatch = ({ value }) => {
  const colorSwatchKey = colorKeyMap[value] || 'other'
  const colorSwatchValue = colorValueMap[colorSwatchKey]
  const style = ['multi', 'metal', 'other'].includes(colorSwatchKey)
    ? {
        backgroundImage: colorSwatchValue,
        backgroundSize: 'cover'
      }
    : {
        backgroundColor: colorSwatchValue,
        ...(colorSwatchKey === 'white' && { border: 'solid 0.5px #b7b3a2' })
      }
  return <span className='mxd-filter-color-swatch' style={style} />
}

export const colorKeyMap = {
  Beige: 'beige',
  Blauw: 'blue',
  Bleu: 'blue',
  Bruin: 'brown',
  Brun: 'brown',
  Geel: 'yellow',
  Jaune: 'yellow',
  Goud: 'gold',
  Doré: 'gold',
  Gris: 'grey',
  Grijs: 'grey',
  Groen: 'green',
  Vert: 'green',
  Koper: 'copper',
  Cuivre: 'copper',
  Multi: 'multi',
  Multicolore: 'multi',
  Oranje: 'orange',
  Orange: 'orange',
  Paars: 'purple',
  Rood: 'red',
  Rouge: 'red',
  Rose: 'pink',
  Roze: 'pink',
  Taupe: 'taupe',
  Zilver: 'silver',
  Argenté: 'silver',
  Zwart: 'black',
  Noir: 'black',
  Metaal: 'metal',
  Métal: 'metal',
  Violet: 'violet',
  Transparent: 'transparent',
  Transparant: 'transparent',
  Wit: 'white',
  Blanc: 'white',
  Anders: 'other'
}

export const colorValueMap = {
  beige: '#f5f5dc',
  blue: '#0000ff',
  brown: '#a52a2a',
  yellow: '#ffff00',
  gold: '#ffd700',
  grey: '#bebebe',
  green: '#228b22',
  copper: '#D06F38',
  multi:
    'conic-gradient(from 0.25turn, #f4ff39, #ffa152 0.15turn, #ff6861 0.31turn, #ff6fed 0.47turn, #4355ff 0.62turn, #4cfbfa 0.78turn, #66ff35 0.94turn, #f4ff39)',
  orange: '#ffa500',
  purple: '#a020f0',
  red: '#ff0000',
  pink: '#ffc0cb',
  taupe: '#d3c3b0',
  transparent: '#dcf0ef',
  white: '#ffffff',
  silver: '#c4cace',
  black: '#000000',
  metal: 'linear-gradient(141.69deg, #C4CACE 15.94%, #FFFFFF 49.84%, #C4CACE 85.2%)',
  violet: '#ee82ee',
  other:
    'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABIUExURUdwTGxwbGpvamlwampwa2pwa2pwampva2x0dGtxa2lvav///7y+vOvs7HB2cdrb2vT09LC0sY2Rjvn6+ZicmX2Dfs3PzqKmo6JVnnUAAAAKdFJOUwA7xaL32JC9EFdDr4qrAAABQElEQVQ4y42U27LDIAhFza1q1aoxaf//Tw9iUxGdM+GpZXZws0CFIKH0Ird13eSilRiHluvzF6vUA8k0P1nME9c8ML9b71Jy3u7499FIlITUKwbzixBfkJLEmtryd2/ThDsgt1WVxOJnaFXG5lrUj4XqBxOZd/U1ZQ0mohnUKj3OpUaEhOcq8DUjQ+jL5cR+/aDuwYUurssx4QRQiakielcwi29bHj77MFGACal82k59MlrZhBZLbu2KD9jyXYNLtlTT6eyY+mwKJuLablqmDmYjwHdikBumCZxzUccURe1xPVM8TvJhMKZovEEwYIoIKMwRU4RJxkKZXkbLWOqAzYhpGXBdFTNgeq3KtXTd4lqydN/17fcI0NT1xYvANwSZWnpB5aBWZkqvVLmch+tt0ct565rfezBuPj33HrH/nsM/200tRURV274AAAAASUVORK5CYII=")'
}
